export default __webpack_public_path__ + "static/media/guestcard.f8422304.png";